import { FunctionComponent, PropsWithChildren } from 'react';

import { Checkbox, FormControl, FormControlLabel } from '@mui/material';

import { BasicInfoComponentProps } from '../../types/basic-info-component.props';

export const SafetyRelevantCheckboxInput: FunctionComponent<
  BasicInfoComponentProps
> = (props: PropsWithChildren<BasicInfoComponentProps>) => {
  const { values, handleChange, handleBlur } = props;

  return (
    <FormControl
      data-testid="safety-relevant-checkbox-input-form-control"
      className="not-centered"
    >
      <FormControlLabel
        label="Safety Relevant"
        value={values.safetyRelevant}
        onChange={handleChange}
        onBlur={handleBlur}
        control={
          <Checkbox
            id="safetyRelevant"
            className="checkbox-input"
            checked={values.safetyRelevant ?? true}
          />
        }
      />
    </FormControl>
  );
};
